/**
 * Welcher Sitzungs-Dialog darf auf einen 401 reagieren? (Hotfix 15.10.2026)
 * apiFetch meldet JEDEN 401 als Fenster-Ereignis. Es gibt drei getrennte
 * Sitzungen: Entra (Verwaltung), Mitarbeiterportal und Schulportal (eigene
 * Cookies). Ein Entra-Admin im Mitarbeiterportal bekam sonst bei jedem 401 von
 * /api/staff/* den Entra-Dialog; "Neu anmelden" fuehrte zurueck, derselbe 401
 * kam wieder: Endlosschleife. Jeder Dialog hoert nur auf SEINEN Bereich.
 */

/** @param {string | undefined | null} path */
const pfad = (path) => (path || '').split('?')[0]

/** Entra-Dialog: alles ausser /api/staff/ (Mitarbeiter- und Schulportal haben eigene Sitzungen). */
export const giltEntra = (/** @type {string | undefined | null} */ path) => !pfad(path).startsWith('/api/staff/')

/** Mitarbeiterportal-Dialog: /api/staff/ ausser /api/staff/schule/. */
export const giltMitarbeiter = (/** @type {string | undefined | null} */ path) => {
  const p = pfad(path)
  return p.startsWith('/api/staff/') && !p.startsWith('/api/staff/schule/')
}

/** Schulportal: /api/staff/schule/ (zeigt keinen Dialog, leitet selbst zur Kartenanmeldung). */
export const giltSchule = (/** @type {string | undefined | null} */ path) => pfad(path).startsWith('/api/staff/schule/')

/**
 * Darf der Dialog mit Praedikat `gilt` auf dieses Ereignis reagieren?
 * Ohne Praedikat: ja (altes Verhalten). Ohne Pfad im Detail: ja (Fail-open,
 * damit eine echte Ablauf-Meldung nie verschluckt wird).
 * @param {((path: string) => boolean) | undefined} gilt
 * @param {unknown} event
 */
export function ereignisGilt(gilt, event) {
  if (!gilt) return true
  const path = /** @type {{ detail?: { path?: string } } | null} */ (event)?.detail?.path
  if (typeof path !== 'string') return true
  return gilt(path)
}
